/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
const isBrowser = typeof window !== 'undefined';

export const addLibraries = (scriptURL, container, IsAsync, IsDefer, id = '') => {
    if (!scriptURL) return;
    if (typeof window !== 'undefined') {
        let selector = document.getElementById(container);
        if (!selector) selector = document.getElementsByTagName('head')[0];
        const scriptSrc = selector.querySelectorAll('script');
        let header_already_added = false;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < scriptSrc.length; i++) {
            if (scriptSrc[i].src === scriptURL) {
                header_already_added = true;
            }
        }

        if (header_already_added) return;
        const script_tag = document.createElement('script');
        // eslint-disable-next-line no-unneeded-ternary
        script_tag.async = IsAsync ? true : false;
        // eslint-disable-next-line no-unneeded-ternary
        script_tag.defer = IsDefer ? true : false;
        script_tag.setAttribute('src', scriptURL);
        script_tag.setAttribute('id', id);
        selector.appendChild(script_tag);
    }
};

/**
 * Call the refreshWidgets function
*/
export const loadYotpoSkeleton = () => {
    let yotpoIsReady = false;
    const yotpoFunc = isBrowser && window.yotpo;
    if (!yotpoFunc) return;
    // eslint-disable-next-line wrap-iife
    (function checkForYotpo() {
        setTimeout(() => {
            if (typeof yotpoFunc !== 'undefined') {
                if (yotpoFunc.initialized === true) {
                    yotpoIsReady = true;
                    yotpoFunc.refreshWidgets();
                }
            }
            if (yotpoIsReady === false) checkForYotpo();
        }, 250);
    })();
};

/**
 * Take the value from data-src and inster that in src
*/
export const loadYotpoImages = () => {
    // eslint-disable-next-line no-use-before-define
    const myInterval = setInterval(refreshYotpo, 300);
    const yotpoFunc = isBrowser && window.yotpo;
    if (!yotpoFunc) {
        clearInterval(myInterval);
        // eslint-disable-next-line no-useless-return
        return;
    }
    function refreshYotpo() {
        const state = yotpoFunc ?  null : yotpoFunc.getState();
        if (!state) return;
        if (state === 'ready') {
            Array.from(document.getElementsByClassName('yotpo-image')).forEach((image) => {
                if (image.hasAttribute('data-src')) {
                    image.setAttribute('src', image.getAttribute('data-src'));
                }
            });
            clearInterval(myInterval);
        }
    }
};

/**
* Truncate a string if it is longer than the specified number of characters
*/
export const blogContentTruncate = (str, length = 100, ending = '...') => {
    if (str.length > length) return str.substring(0, length - ending.length) + ending;
    return str;
};
